import { createSlice } from '@reduxjs/toolkit';

import {
  getStudentById,
  updateStudentById,
  grantStudentCoursesAccess,
} from './actions';

const studentSlice = createSlice({
  name: 'currentStudent',
  initialState: null,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getStudentById.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(updateStudentById.fulfilled, (state: any, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    });

    builder.addCase(
      grantStudentCoursesAccess.fulfilled,
      (state: any, action: any) => {
        state.courses = action.payload;
      },
    );
  },
});

export default studentSlice.reducer;
